import { render, staticRenderFns } from "./KeywordsIdeasCard.vue?vue&type=template&id=39ac2064&scoped=true"
import script from "./KeywordsIdeasCard.vue?vue&type=script&lang=js"
export * from "./KeywordsIdeasCard.vue?vue&type=script&lang=js"
import style0 from "./KeywordsIdeasCard.vue?vue&type=style&index=0&id=39ac2064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ac2064",
  null
  
)

export default component.exports